import logoConduccoAllWhite from 'assets/logo-conducco-all-white.svg'
import logoConduccoIcon from 'assets/logo-conducco-icon.svg'

// why: o literal '/assets/...' nao existe no build do Vite (os assets saem com hash); so o import resolve para a URL servida. O literal dava 404 em producao.
export const FALLBACK_LOGO = {
  base: logoConduccoAllWhite,
  white: logoConduccoIcon,
  black: '',
}
